import React, { useContext } from "react";

import { WeeklyContext } from "../../../context/global/WeeklyContext";
import {
  ChevronLeft,
  ChevronRight,
} from "../../../components/icons/svg/outline";

/**
 * Week navigation for the Dispatch: previous week, jump to the current week,
 * and next week. Styled to match the Schedule timeline navigation buttons.
 *
 * @component
 * @returns {JSX.Element} The rendered week switcher.
 */
const DispatchSwitcher = () => {
  const { resetWeekStart, goToNextWeek, goToPrevWeek } =
    useContext(WeeklyContext);

  return (
    <div className="flex shrink-0 items-center gap-1">
      <button
        type="button"
        onClick={() => goToPrevWeek()}
        aria-label="Previous week"
        title="Previous week"
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded border border-gray-300 bg-white text-gray-700 hover:bg-gray-200"
      >
        <ChevronLeft className="h-4 w-4" aria-hidden />
      </button>
      <button
        type="button"
        onClick={() => resetWeekStart()}
        className="h-6 shrink-0 rounded border border-gray-300 bg-white px-2.5 text-xs font-medium text-gray-700 hover:bg-gray-200"
      >
        Today
      </button>
      <button
        type="button"
        onClick={() => goToNextWeek()}
        aria-label="Next week"
        title="Next week"
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded border border-gray-300 bg-white text-gray-700 hover:bg-gray-200"
      >
        <ChevronRight className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
};

export default DispatchSwitcher;
